import React from "react";
import { Link } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "16px",
  },
  label: {
    color: theme.palette.common.black,
  },
  field: {
    color: theme.palette.grey[400],
    marginTop: "16px",
  },
  link: {
    textDecoration: "none",
    color: theme.palette.primary.main,
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

interface Props {
  label: string;
  value: string;
  link?: string;
  style?: Object;
  onLinkClick?: () => void;
}

const KLabel = ({
  label,
  value,
  link = "",
  style = {},
  onLinkClick = () => {},
}: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.root} style={style}>
      <Typography variant="body2" className={classes.label}>
        {label}
      </Typography>
      <Typography variant="body2" className={classes.field}>
        {link.length > 0 ? (
          <div onClick={onLinkClick}>
            <Link to={link} className={classes.link}>
              {value}
            </Link>
          </div>
        ) : (
          value
        )}
      </Typography>
    </div>
  );
};

export default KLabel;
